import { useContext } from 'react'
import UserContext from '../context/UserContextProvider'

const useOwnUser = () => {
  return useContext(UserContext)
}

export default useOwnUser
